module.exports = __webpack_public_path__ + "img/arrow-down-progress.d090aa7e.svg";